import { render, staticRenderFns } from "./BaseMenuOptions.vue?vue&type=template&id=4ad82975&scoped=true"
import script from "./BaseMenuOptions.vue?vue&type=script&lang=js"
export * from "./BaseMenuOptions.vue?vue&type=script&lang=js"
import style0 from "./BaseMenuOptions.vue?vue&type=style&index=0&id=4ad82975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad82975",
  null
  
)

export default component.exports